module.exports = __webpack_public_path__ + "img/服務條款1.2919f912.png";